<template>
  <div class="login-overlay">
    <div class="login-modal">
      <button class="close-btn" @click="router.back()">✕</button>

      <h2 class="login-title">Genius College Advice on Demand!</h2>

      <!-- Google Sign-In -->
      <div class="google-login">
        <div
          id="g_id_onload"
          data-client_id="781028687161-eu7u44p51khc4mbm5067rfchfub7ial0.apps.googleusercontent.com"
          data-context="signin"
          data-ux_mode="popup"
          data-callback="handleCredentialResponse"
          data-auto_prompt="false"
        ></div>

        <!-- Updated attributes for modern button look -->
        <div
          class="g_id_signin"
          data-type="standard"
          data-shape="pill"
          data-theme="filled_blue"
          data-text="continue_with"
          data-logo_alignment="left"
        ></div>

        <p v-if="error" class="error-text">
          <span>⚠️</span> {{ error }}
        </p>
      </div>

      <!-- Divider -->
      <div class="divider">
        <span>or</span>
      </div>

      <!-- Email Login -->
      <form @submit.prevent="login" class="email-login">
        <input
          type="text"
          v-model="email"
          placeholder="Enter Email Address"
          required
        />
        <input
  type="password"
  v-model="password"
  placeholder="Enter Password"
  required
/>
        <button type="submit" class="email-button">Continue with Email</button>
      </form>

      <!-- Footer -->
      <div class="footer-links">
        College Students:
        <a href="/careers" class="footer-link">Share your Genius, Join our Team</a>
      </div>
    </div>
  </div>
</template>

<script>
const API_BASE = process.env.VUE_APP_API_BASE_URL || '/api';
const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID || ''
import { useRouter } from "vue-router";

export default {
  name: "LoginView",
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return {
      GOOGLE_CLIENT_ID,
      email: "",
      password: "",
      error: "",
    };
  },
  methods: {
    async login() {
      try {
        const response = await fetch(`${API_BASE}/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ email: this.email, password: this.password }),
        });
        const data = await response.json();
        if (data.message) {
          this.error = data.message;
          return;
        }
        window.location.assign("/");
      } catch (err) {
        this.error = "Something went wrong. Please try again.";
      }
    },
    async handleCredentialResponse({ credential }) {
      try {
        if (!credential) {
          this.error = "Google sign-in failed: no credential.";
          return;
        }
        const res = await fetch(`${API_BASE}/auth/google/one-tap`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include", // IMPORTANT for session cookie
          body: JSON.stringify({ credential }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.message || "Google sign-in failed.");
        }
        // Force a full page reload so the session cookie is applied everywhere
        window.location.assign("/");
      } catch (e) {
        console.error(e);
        this.error = e.message || "Google sign-in failed.";
      }
    },
  },
  mounted() {
    window.handleCredentialResponse = this.handleCredentialResponse.bind(this);

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  },
  unmounted() {
    // cleanup
    delete window.handleCredentialResponse;
  }
};
</script>

<style>
/* Background overlay */
.login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(20, 20, 20, 0.5); */
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.55)), /* dark overlay */
    url("../../assets/images/other/content-page.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Modal container */
.login-modal {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 40px 60px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  text-align: center;
}

/* Close button */
.close-btn {
  position: absolute;
  top: 10px;
  right: 14px;
  background: transparent; /* Ensures transparent background */
  color: #000 !important; /* Forces the '✕' character to be black */
  border: none;
  font-size: 22px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: #0056b3 !important;
  background: transparent;
}

.login-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 25px;
}

/* Google button section */
.google-login {
  margin-bottom: 20px;
}
/* Ensure text is white and bold */
.g_id_signin span {
  color: #fff !important;
  font-weight: 700 !important;
  letter-spacing: 0.3px !important;
}

/* Error text */
.error-text {
  color: red;
  margin-top: 10px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

/* Divider */
.divider {
  position: relative;
  margin: 25px 0;
  text-align: center;
}
.divider::before,
.divider::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 40%;
  height: 1px;
  background-color: #ccc;
}
.divider::before {
  left: 0;
}
.divider::after {
  right: 0;
}
.divider span {
  background: #fff;
  padding: 0 10px;
  color: #777;
  font-size: 14px;
}

/* Email form */
.email-login input {
  width: 100%;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 15px;
}

.email-button {
  width: 100%;
  padding: 12px;
  background-color: #4caf50;
  color: white;
  font-size: 15px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}
.email-button:hover {
  background-color: #43a047;
}

/* Footer links */
.footer-links {
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  margin-top: 25px;
  color: #444;
}
.footer-link {
  color: #007bff;
  text-decoration: none;
}
.footer-link:hover {
  text-decoration: underline;
}
</style>
